import { styled } from '@mui/material/styles';
import MuiTableHead from '@mui/material/TableHead';
import type { ReactNode } from 'react';
import { useIsToolbarVisible } from './Toolbar';

const StyledTableHead = styled(MuiTableHead, {
  name: 'Table',
  slot: 'TableHead',
})({
  position: 'sticky',
  zIndex: 10,
});

export const TableHead = ({ children }: { children?: ReactNode }) => {
  const isToolbarVisible = useIsToolbarVisible();

  return (
    <StyledTableHead sx={{ top: isToolbarVisible ? 36 : 0 }}>
      {children}
    </StyledTableHead>
  );
};
